import { api, defineWebModule } from '@itc/sdk';
import { getCounts, searchSupply } from '../shared/endpoints.ts';
import { SHIPS_TOPIC, STOCK_TOPIC } from '../shared/topics.ts';

const drafts = () => import('./reports.ts');
const images = () => import('./cards.ts');

// Supply in the shell (design §7.5, plan 2B): the Supply page (Chunk 3), the Ships
// page (Chunk 4) and the Refinery (Chunk 5); on Home, Sierra's Bridge panels; on
// the nav, live badges for low stock and ships that need a restock (Chunk 6). Its
// settings form comes from its schema.
export default defineWebModule({
  name: 'supply',
  title: 'Supply',
  search: { permissions: ['supply.view'], run: async (q, signal) => (await api(searchSupply, { query: { q } }, { signal })).hits },
  cards: [
    { id: 'supply.status', label: 'Supply status', permission: 'supply.view', spec: async () => (await images()).supplyImage() },
    { id: 'supply.readiness', label: 'Ship readiness', permission: 'supply.view', spec: async () => (await images()).readinessImage() },
  ],
  reports: [
    { type: 'supply', permission: 'supply.view', draft: async () => (await drafts()).supply() },
    { type: 'readiness', permission: 'supply.view', draft: async () => (await drafts()).readiness() },
  ],
  routes: [
    { path: '/supply', component: () => import('./pages/SupplyPage.vue'), meta: { permission: 'supply.view', title: 'Supply' } },
    { path: '/supply/ships', component: () => import('./pages/ShipsPage.vue'), meta: { permission: 'supply.view', title: 'Ships' } },
    // Every member may keep personal refinery jobs (plan 2B Open Question 1).
    { path: '/supply/refinery', component: () => import('./pages/RefineryPage.vue'), meta: { permission: 'authenticated', title: 'Refinery' } },
  ],
  nav: [
    {
      label: 'Supply',
      to: '/supply',
      permission: 'supply.view',
      icon: 'supply',
      // R18: low stockpile prep levels, as the Supply page counts them.
      badge: { permission: 'supply.view', count: async () => (await api(getCounts)).low, topics: () => [STOCK_TOPIC, SHIPS_TOPIC], label: (count) => `${String(count)} low` },
    },
    {
      label: 'Ships',
      to: '/supply/ships',
      permission: 'supply.view',
      icon: 'ships',
      // R18: stocked ships that need a restock, as the board counts them.
      badge: { permission: 'supply.view', count: async () => (await api(getCounts)).short, topics: () => [STOCK_TOPIC, SHIPS_TOPIC], label: (count) => `${String(count)} need restock` },
    },
    { label: 'Refinery', to: '/supply/refinery', permission: 'authenticated', icon: 'refinery' },
  ],
  // Sierra's Bridge panels for supply (lines 913–936), for those who may see each.
  widgets: [
    { id: 'supply.stock', title: 'Supply', permission: 'supply.view', component: () => import('./widgets/SupplyWidget.vue') },
    { id: 'supply.ships', title: 'Ships', permission: 'supply.view', component: () => import('./widgets/ShipsWidget.vue') },
    { id: 'supply.refinery', title: 'Refinery', permission: 'authenticated', component: () => import('./widgets/RefineryWidget.vue') },
    { id: 'supply.activity', title: 'Supply activity', permission: 'supply.view', component: () => import('./widgets/ActivityWidget.vue') },
  ],
});
